import { arrayToMap, groupBy } from 'lib/array/arrayUtils'

/** Attach room metadata only when insured minor slots match the hotel occupants exactly. */
export default function associateInsuranceRoomGuests(
  travellers: Array<App.Checkout.TravellerFormSchemaOccupant>,
  rooms: Array<App.Checkout.AccommodationSchemaRequestItem>,
): Array<App.Checkout.TravellerFormSchemaOccupant> {
  const occupants = rooms.flatMap(room => (room.occupants ?? []).map(occupant => ({
    ...occupant,
    relatedItem: room.requireLeadGuestNames === true ? occupant.relatedItem : undefined,
  })))
  const roomOccupantsByType = groupBy(occupants.filter(occupant => occupant.type !== 'adult'), occupant => occupant.type)
  const travellersByType = groupBy(travellers.map((traveller, index) => ({ traveller, index })), entry => entry.traveller.type)
  const associatedTravellersByIndex = arrayToMap(
    Array.from(travellersByType).flatMap(([type, entries]) => {
      const matchingOccupants = roomOccupantsByType.get(type)
      if (type === 'adult' || matchingOccupants?.length !== entries.length) return entries
      return entries.map((entry, index) => {
        const relatedItem = matchingOccupants[index]?.relatedItem
        if (!relatedItem?.id) return entry
        return { ...entry, traveller: { ...entry.traveller, relatedItem } }
      })
    }),
    entry => entry.index,
    entry => entry.traveller,
  )

  return travellers.map((traveller, index) => associatedTravellersByIndex.get(index) ?? traveller)
}
